import { render, staticRenderFns } from "./ProfileGroup.vue?vue&type=template&id=b833a2ee&"
import script from "./ProfileGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports